import { lazy } from 'react';
import { ToolConfig } from '@/types/tool';

export const homeConfig: ToolConfig = {
  id: 'home',
  path: '/',
  meta: {
    title: '0x-tools',
    description: 'Privacy-first developer utilities',
    keywords: ['home', 'tools', 'utilities'],
    icon: 'Home',
  },
  component: lazy(() => import('./Home')),
};
